import PropTypes from "prop-types";
import styles from "./UpSellCarouselHeader.css";

const UpSellCarouselHeader = ({ title, subtitle, itemCount }) => (
  <div className={styles.header}>
    <div className={styles.title}>
      <div className={styles.titleLineOne}>{subtitle}</div>
      <div className={styles.titleLineTwo}>{title}</div>
    </div>
    <div className={styles.itemCounter}>{itemCount}</div>
  </div>
);

UpSellCarouselHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  itemCount: PropTypes.string.isRequired
};

export default UpSellCarouselHeader;
